// Central logging configuration
const LOGGING_CONFIG = {
  enabled: true, // Console logging enabled
  levels: {
    log: true,
    warn: true,
    error: true,
    info: true,
    debug: false // Debug logs disabled by default
  }
};

// Suppress Vue warnings
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.config.silent = true;
  window.Vue.config.warnHandler = () => {};
}

// For Vue 3
if (typeof window !== 'undefined' && window.__VUE__) {
  window.__VUE_OPTIONS_API__ = true;
  window.__VUE_PROD_DEVTOOLS__ = false;
}

// Logger utility
export const logger = {
  log: (...args) => {
    if (LOGGING_CONFIG.enabled && LOGGING_CONFIG.levels.log) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (LOGGING_CONFIG.enabled && LOGGING_CONFIG.levels.warn) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (LOGGING_CONFIG.enabled && LOGGING_CONFIG.levels.error) {
      console.error(...args);
    }
  },
  info: (...args) => {
    if (LOGGING_CONFIG.enabled && LOGGING_CONFIG.levels.info) {
      console.info(...args);
    }
  },
  debug: (...args) => {
    if (LOGGING_CONFIG.enabled && LOGGING_CONFIG.levels.debug) {
      console.debug(...args);
    }
  }
};

// Configuration methods
export const setLoggingEnabled = (enabled) => {
  LOGGING_CONFIG.enabled = enabled;
};

export const setLogLevel = (level, enabled) => {
  if (Object.prototype.hasOwnProperty.call(LOGGING_CONFIG.levels, level)) {
    LOGGING_CONFIG.levels[level] = enabled;
  }
};

// Suppress Vue warnings globally
export const suppressVueWarnings = () => {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.config.silent = true;
    window.Vue.config.warnHandler = () => {};
  }
  if (typeof window !== 'undefined') {
    window.__VUE_OPTIONS_API__ = true;
    window.__VUE_PROD_DEVTOOLS__ = false;
  }
};